import plural from 'helpers/plural';

angular.module('filters').filter('pluralize', function() {
  return function(word, number, includeCount) {
    if (!word || (!number && number !== 0)) {
      return;
    }
    return plural(word, number, includeCount);
  };
});
